<script setup lang="ts">
import idealLinks from '~/constants/ideal-links'
</script>

<template>
  <DonateContentSection title="iDeal" icon="bx:donate-heart">
    <div class="mb-4 grid grid-cols-3 gap-2">
      <DonateContentButtonIdealSuggestedAmount :ideal-link="idealLinks.get('5')" />
      <DonateContentButtonIdealSuggestedAmount :ideal-link="idealLinks.get('20')" />
      <DonateContentButtonIdealSuggestedAmount :ideal-link="idealLinks.get('50')" />
    </div>
    <DonateContentButton :to="idealLinks.get('any')?.href ?? ''" :label="idealLinks.get('any')?.label ?? ''" />
  </DonateContentSection>
</template>
